import { isFromGoogleDoc } from './googleDoc/isFromGoogleDoc';
import { transformGoogleDocHtml } from './googleDoc/transformGoogleDocHtml';
import { ICopyPasteConverterOptions } from './types';

const DEFAULT_OPTIONS: ICopyPasteConverterOptions = {
  ignoreImage: false,
};

export const htmlConverter = (
  htmlText: string,
  rawOptions?: ICopyPasteConverterOptions
): string | null => {
  const options: ICopyPasteConverterOptions = Object.assign({}, DEFAULT_OPTIONS, rawOptions);

  const div = document.createElement('div');
  div.innerHTML = htmlText;
  const nodes = div.getElementsByTagName('*');

  if (isFromGoogleDoc(nodes)) {
    return transformGoogleDocHtml(htmlText, options);
  }

  return null;
};
